import React, { useState } from "react";
import { Modal, Button, Form, Input, Select } from "antd";
import ButtonComp from "../../Components/ButtonComp/ButtonComp";
import {
  CloseCircleFilled,
  CheckCircleFilled,
  cancelCircle,
} from "../../Utils/imports";
import { useDispatch, useSelector } from "react-redux";
import { forceStopShift } from "../../API-Interaction/apiServices/logs.api";
import {
  antIcon,
  canForceStop,
  formatCapabilities,
} from "../../Helpers/helpers";
const { Option } = Select;
const ForceShiftStop = () => {
  const { current = null, lists } = useSelector((state) => state.plant);
  const [FSModal, setFSModal] = useState(false);
  const [selectedMachines, setSelectedMachines] = useState([current?.machine?.machineName]);
  const [step, setStep] = useState(1);
  const dispatch = useDispatch();
  const handleModalOpen = () => {
    setSelectedMachines([current?.machine?.machineName])
    setFSModal(true);
  };
  function canSync() {
    if ((lists?.machines.length>1))
      return true
    return false
  }
  function canSyncMachine(x){
      const { machine } = current;
      if ((!machine && x.machineName == 'Default') || (machine && x.machineName == machine.machineName))
        return true
      return false
    
  }
  const handleModalClose = () => {
    setFSModal(false);
    setStep(1);
  };

  const handleForceStop = async () => {

    await forceStopShift(dispatch, current,selectedMachines);
    handleModalClose();
  };

  return (
    <div className="dflex">
      <ButtonComp
        onClick={handleModalOpen}
        theme={canForceStop(current, lists) ? "red" : "gray"}
        text="Force Stop"
        icon={<img src={cancelCircle} />}
        style={{ minWidth: "120px" }}
      />
      <Modal
        title={<h2 style={{ fontWeight: "bold" }}>Force Stop</h2>}
        centered
        maskClosable={false}
        open={FSModal}
        onCancel={handleModalClose}
        footer={null}
        className="fsModal"
      >
        {step === 1 && (
          <div>
            <h4
              style={{
                fontWeight: 600,
                fontSize: 14,
                textTransform: "uppercase",
                textAlign: "center",
              }}
            >
              Are you sure you want to stop this shift early?
            </h4>
            <h4>
              Current Machine: <strong>{current?.machine?.displayName}</strong>
            </h4>
            <h4>
              Current SHIFT: <strong>{current?.shift?.name}</strong>
            </h4>
            <h4>
              Shift Range : <strong>{current?.shift?.range}</strong>
            </h4>
            <div className="dflex alignCenter justifyCenter gap10">
              <ButtonComp
                className="btnBlue"
                style={{ width: "100px" }}
                theme="blue"
                text="Yes"
                onClick={() => canSync()?setStep(2):handleForceStop()}
                icon={<CheckCircleFilled />}
              />
              <ButtonComp
                className="btnBlue"
                style={{ width: "100px" }}
                theme="red"
                text="No"
                onClick={() => handleModalClose()}
                icon={<CloseCircleFilled />}
              />
            </div>
          </div>
        )}
        {step === 2 && (
          <div className="width100P">
            <h4 style={{ fontWeight: "bold" }}>Select Machine to Sync</h4>
            <Form>
              <Form.Item name="machine name">
                <Select mode="multiple"
                placeholder="Select a machine"
                onChange = {(machines) => {setSelectedMachines(machines)}}
                defaultValue={selectedMachines}>
                  {lists?.machines.map(x => (
                    <Option disabled={canSyncMachine(x) ?  true :false } key={x.machineName} value={x.machineName}>
                      {x.displayName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <div className="dflex alignCenter justifyCenter gap10">
                <ButtonComp
                  className="btnBlue"
                  style={{ width: "100px" }}
                  theme="blue"
                  text="Proceed"
                  onClick={() => handleForceStop()}
                  icon={<CheckCircleFilled />}
                />
                <ButtonComp
                  className="btnBlue"
                  style={{ width: "100px" }}
                  theme="red"
                  text="Cancel"
                  onClick={() => handleModalClose()}
                  icon={<CloseCircleFilled />}
                />
              </div>
            </Form>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ForceShiftStop;
